module.exports = __webpack_public_path__ + "static-m/img/empty.6d96dd67.png";